module.exports = __webpack_public_path__ + "img/logo-white.dc30270c.svg";